import { render } from "./searchs.vue?vue&type=template&id=1cbb970c&scoped=true&ts=true"
import script from "./searchs.vue?vue&type=script&lang=ts"
export * from "./searchs.vue?vue&type=script&lang=ts"

import "./searchs.vue?vue&type=style&index=0&id=1cbb970c&lang=less&scoped=true"

import exportComponent from "E:\\develop\\EBIEarthWebApp\\n-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbb970c"]])

export default __exports__